import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import '@web/shared-digital-library/icons/svg-originals/bag.svg';
import '@web/shared-digital-library/icons/svg-originals/account.svg';
import '@web/shared-digital-library/icons/svg-originals/account-on.svg';
import '@web/shared-digital-library/icons/svg-originals/account-connected.svg';
import '@web/shared-digital-library/icons/svg-originals/infobulle.svg';
import '@web/shared-digital-library/icons/svg-originals/geoloc.svg';
import IconTextLink from '~/components/molecules/Header/IconTextLink.vue';
import AccountLayer from '~/components/specific/MainHeader/AccountLayer.vue';
import BannerSeller from '~/components/specific/MainHeader/BannerSeller.vue';
import marketClosed from '~/helpers/marketClosed';
var MdmLink = function MdmLink() {
  return import('~/components/atoms/MdmLink.vue');
};
var SearchItem = function SearchItem() {
  return import('~/components/specific/TheHeader/Menu/SecondaryNav/Items/SearchItem.vue');
};
export default {
  name: 'Banner',
  components: {
    SearchItem: SearchItem,
    IconTextLink: IconTextLink,
    AccountLayer: AccountLayer,
    BannerSeller: BannerSeller,
    MdmLink: MdmLink
  },
  props: {
    cartUrl: {
      type: String,
      default: ''
    },
    homeUrl: {
      type: String,
      default: ''
    },
    helpUrl: {
      type: String,
      default: ''
    },
    accountUrl: {
      type: String,
      default: ''
    },
    storeLocUrl: {
      type: String,
      default: ''
    },
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      accountHover: false,
      faqOpen: false,
      isMounted: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    cart: 'cart/total',
    user: 'user/me',
    locale: 'i18n/locale'
  })), {}, {
    accountDescription: function accountDescription() {
      return this.user ? this.$t('account-greeting', {
        name: this.user.firstName
      }) : this.$t('account-description');
    },
    accountIcon: function accountIcon() {
      if (this.accountHover) return 'account-on';
      return this.user ? 'account-connected' : 'account';
    },
    hasToggleShop: function hasToggleShop() {
      return process.client && this.$cookies.get('MDM_TOGGLE_SHOP');
    },
    isMarketOpen: function isMarketOpen() {
      if (!this.locale) return true;
      var market = this.locale.market;
      return !marketClosed({
        market: market
      });
    }
  }),
  mounted: function mounted() {
    this.isMounted = true;
  },
  methods: {
    tracking: function tracking(evt, data) {
      this.$root.$emit('generic-tracking', evt, {
        data: _objectSpread({
          event_category: 'Header',
          event_action: '',
          event_label: ''
        }, data)
      });
    },
    open: function open(item) {
      item.setAttribute('aria-expanded', true);
    },
    close: function close(item) {
      item.setAttribute('aria-expanded', false);
    },
    faqClick: function faqClick(event) {
      this.tracking(event, {
        event_action: 'Aide et contact'
      });
      this.faqOpen = false;
    },
    navigate: function navigate(event, eventAction, url) {
      this.tracking(event, eventAction);
      window.location.assign(url);
    }
  }
};